export default "__VITE_ASSET__B$ilQKXJ__"